import { formatTripDates } from '@/data/trips';
import type { SelectOption } from '@/components/ui/SelectField';
import type { Trip } from '@/services/trips';
import { isTripCompleted } from '@/utils/tripStatus';

const CURRENT_SECTION_ID = '__trip_section_current';
const COMPLETED_SECTION_ID = '__trip_section_completed';

export function buildTripSelectOptions(trips: Trip[]): SelectOption[] {
  if (!trips || trips.length === 0) {
    return [];
  }

  const current: SelectOption[] = [];
  const completed: SelectOption[] = [];
  const archived: SelectOption[] = [];

  trips.forEach((trip) => {
    if (!trip.id) {
      return;
    }

    const tripDates = formatTripDates(trip.startDate, trip.endDate);
    const statusLabel = trip.isArchived ? 'Archived' : isTripCompleted(trip) ? 'Completed' : null;
    const option: SelectOption = {
      value: trip.id,
      label: trip.name,
      type: 'option',
      meta: statusLabel ? `${tripDates} • ${statusLabel}` : tripDates,
    };

    if (trip.isArchived) {
      archived.push(option);
      return;
    }

    if (isTripCompleted(trip)) {
      completed.push(option);
      return;
    }

    current.push(option);
  });

  const ordered: SelectOption[] = [];

  if (current.length > 0) {
    ordered.push({
      value: CURRENT_SECTION_ID,
      label: 'Current Trips',
      type: 'section',
    });
    ordered.push(...current);
  }

  if (completed.length > 0 || archived.length > 0) {
    ordered.push({
      value: COMPLETED_SECTION_ID,
      label: 'Completed / Archived',
      type: 'section',
    });
    ordered.push(...completed, ...archived);
  }

  return ordered;
}




